import React, { FC, Suspense, useEffect } from 'react'
import Box from '@mui/material/Box'
import { CircularProgress } from '@mui/material'

import EmptyData from '../../../../components/EmptyData'
import { AppIcon } from '../../../../components/AppIcon'
import { useTypedSelector } from '../../../../hooks/useTypedSelector'
import OrgSettingsBodyBase from '../OrganizationSettings/OrgSettingsBodyBase'
import { getTaskList } from '../../../../store/reducers/schedule/tasks/actions'
import { selectTasks } from '../../../../store/reducers/schedule/tasks/selectors'
import { useDefaultComponentTools } from '../../../../hooks/useDefaultComponentTools'

const TasksTablePagination = React.lazy(
	() => import(/* webpackChunkName: "tasks_table" */ './TasksTablePagination')
)

const TasksPageWrapper: FC = () => {
	const { loading, setLoading, dispatch, isMounted, alert } =
		useDefaultComponentTools(true)
	const rows = useTypedSelector(selectTasks)

	useEffect(() => {
		const fetchTasks = async (): Promise<void> => {
			try {
				await dispatch(getTaskList())
			} catch (e: any) {
				'message' in e && e.message && alert.error(e.message)
			} finally {
				isMounted() && setLoading(false)
			}
		}

		fetchTasks()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch])

	return (
		<OrgSettingsBodyBase>
			{loading && (
				<Box textAlign={'center'} my={'auto'}>
					<CircularProgress />
				</Box>
			)}

			{!loading && !!rows.length && (
				<Suspense
					fallback={
						<Box
							display={'flex'}
							alignItems={'center'}
							justifyContent={'center'}
							my={'auto'}
							height={'100%'}
						>
							<CircularProgress />
						</Box>
					}
				>
					<TasksTablePagination />
				</Suspense>
			)}

			{!loading && !rows.length && (
				<Box
					display={'flex'}
					alignItems={'center'}
					justifyContent={'center'}
					flexDirection={'column'}
					my={'auto'}
				>
					<EmptyData
						iconSlot={
							<AppIcon type={'catShowIntoBox'} width={140} />
						}
						title={'Ouhh It’s empty in here.'}
					/>
				</Box>
			)}
		</OrgSettingsBodyBase>
	)
}

export default TasksPageWrapper
